"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
exports.ErrorCode = {
    VALIDATION_ERROR: "VALIDATION_ERROR",
    NOT_FOUND: "NOT_FOUND",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    CONFLICT: "CONFLICT",
    PERIOD_LOCKED: "PERIOD_LOCKED",
    NORM_CONFLICT_UNRESOLVED: "NORM_CONFLICT_UNRESOLVED",
    CALCULATION_POLICY_MISSING: "CALCULATION_POLICY_MISSING",
    /** "Potvrdi unos" (confirm) requires total logged minutes to exactly
     * equal the active daily fund from Company Performance Settings — see
     * DailyEntryService.updateStatus (2026-09-09 brainstorm). The frontend
     * maps this to a non-technical message rather than generic VALIDATION_ERROR
     * text, same reasoning as CALCULATION_POLICY_MISSING above. */
    DAILY_ENTRY_MINUTES_MISMATCH: "DAILY_ENTRY_MINUTES_MISMATCH",
    /** On-demand PDF export is momentarily at its concurrency limit on a
     * small production host — a transient, retryable 503, never a failure of
     * the report itself. The frontend maps this to a "try again in a moment"
     * message rather than a generic error. */
    REPORT_PDF_BUSY: "REPORT_PDF_BUSY",
    INTERNAL: "INTERNAL",
};
//# sourceMappingURL=errors.js.map